import { FormControl, FormGroup, Validators } from '@angular/forms';

export class NoteForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyId: FormControl<number | undefined | null>;
  VendorId: FormControl<number | undefined | null>;
  ExemptVendorId: FormControl<number | undefined | null>;
  ClientRegisteredVendorId: FormControl<number | undefined | null>;
  UserId: FormControl<number | undefined | null>;
  ticketId: FormControl<string | undefined | null>;
  EmailId: FormControl<number | undefined | null>;
  title: FormControl<string | undefined>;
  note: FormControl<string | undefined>;
  isSensitive: FormControl<boolean | undefined>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      CompanyId: new FormControl<number | undefined>(undefined),
      VendorId: new FormControl<number | undefined | null>(undefined),
      ExemptVendorId: new FormControl<number | undefined | null>(undefined),
      ClientRegisteredVendorId: new FormControl<number | undefined | null>(
        undefined
      ),
      UserId: new FormControl<number | undefined | null>(undefined),
      ticketId: new FormControl<string | undefined | null>(undefined),
      EmailId: new FormControl<number | undefined | null>(undefined),
      title: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      note: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isSensitive: new FormControl<boolean | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      )
    });
  }
}
